.ActiveUsersList {
	display: flex;
	flex-direction: column;
	width: 100%;
	text-align: left;
}
.ActiveUsersList--preview {
}
.ActiveUsersList--full {
	display: flex;
	flex-direction: column;
}
.ActiveUsersListItem {
	border-radius: 15px;
	transition: background-color 150ms ease, box-shadow 150ms ease;
	margin-left: calc(0px - var(--space-x));
	margin-right: calc(0px - var(--space-x));
}
.ActiveUsersListItem--preview {
	--title-font: var(--title-tiny);
	--info-font: var(--body-small);
	--space-x: 20px;
	--space-y: 15px;
}
.ActiveUsersListItem--full {
	--title-font: var(--title-small);
	--info-font: var(--body-regular);
	--space-x: 30px;
	--space-y: 20px;
	row-gap: 10px;
}
.ActiveUsersListItem--preview + .ActiveUsersListItem--preview {
	margin-top: 10px;
}
.ActiveUsersListItem--full + .ActiveUsersListItem--full {
	margin-top: 20px;
}

.ActiveUsersListItem:hover {
}
.ActiveUsersListItem__link:after {
	content: '';
	grid-row: 1 / -1;
	grid-column: 2;
	display: inline-block;
	width: 30px;
	height: 100%;
	background-size: 14px auto;
	background-repeat: no-repeat;
	background-position: center right;
	background-image: url('~/src/assets/icons/chevron-right.svg');
	transition: transform 150ms ease;
}
.ActiveUsersListItem__link:hover:after {
	transform: translateX(3px);
}

.ActiveUsersListItem__link {
	text-decoration: none;
	display: grid;
	grid-template-rows: auto auto auto;
	grid-template-columns: 1fr auto;
	padding: var(--space-y) var(--space-x);
	gap: inherit;
	cursor: pointer;
}
.ActiveUsersListItem__link:hover {
	text-decoration: none;
}
.ActiveUsersListItem__name {
	text-align: left;
	font: var(--title-font);
	grid-row: 1;
	grid-column: 1;
}
.ActiveUsersListItem__email {
	font: var(--info-font);
	grid-row: 2;
	grid-column: 1;
}
.ActiveUsersListItem__actions {
	grid-row: 3;
	grid-column: 1;
	cursor: default;
	display: flex;
	grid-gap: 20px;
}
.ActiveUsersListItem__actionItem {
}
